import { FC, ReactNode } from 'react';
import { Box, Paper, SxProps, Theme } from '@mui/material';
import { QcsTypography } from './QcsTypography';

interface InfoPaperProps {
  /** Optional section title shown in the header row. */
  title?: ReactNode;
  /** Optional header action (e.g. an edit button) aligned to the right of the title. */
  action?: ReactNode;
  children: ReactNode;
  sx?: SxProps<Theme>;
}

/**
 * Outlined Paper container for a block of read-only info fields (pairs well with {@link ReadOnlyField}).
 * Renders an optional title/action header row above the content.
 */
export const InfoPaper: FC<InfoPaperProps> = ({ title, action, children, sx }) => (
  <Paper variant="outlined" sx={[{ mt: 2, p: 2, borderRadius: 2, borderColor: 'divider' }, ...(sx ? (Array.isArray(sx) ? sx : [sx]) : [])]}>
    {(title || action) && (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
        {title && (
          <QcsTypography variant="body2" sx={{ fontWeight: 600, fontSize: '1rem' }}>
            {title}
          </QcsTypography>
        )}
        {action}
      </Box>
    )}
    {children}
  </Paper>
);
